import styled from 'styled-components';
import { colorUsage } from 'stylesheet';
export var RootContainer = styled.div.withConfig({
  displayName: "Rootstyle__RootContainer",
  componentId: "sc-16grwjp-0"
})(["display:flex;flex-direction:column;align-items:stretch;min-height:100vh;background-color:", ";"], colorUsage.pageBackground);
export var PageContent = styled.main.withConfig({
  displayName: "Rootstyle__PageContent",
  componentId: "sc-16grwjp-1"
})(["display:flex;flex-grow:1;justify-content:center;"]);